import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';
import { contractorService } from '@/services/contractorService';

export function StripeOAuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { toast } = useToast();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    handleCallback();
  }, []);

  const handleCallback = async () => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (error) {
      setError(errorDescription || 'Connection cancelled or failed');
      setTimeout(() => {
        navigate('/contractor/settings');
      }, 3000);
      return;
    }

    if (!code || !state) {
      setError('Invalid callback parameters');
      setTimeout(() => {
        navigate('/contractor/settings');
      }, 3000);
      return;
    }

    try {
      const response = await contractorService.handleStripeCallback(code, state);
      
      if (response.connected) {
        toast({
          title: 'Success!',
          description: 'Your Stripe account has been connected successfully',
        });
        
        // Return to previous page or settings
        const returnPath = sessionStorage.getItem('stripe_oauth_return') || '/contractor/settings';
        sessionStorage.removeItem('stripe_oauth_return');
        navigate(returnPath);
      } else {
        throw new Error('Connection failed');
      }
    } catch (error) {
      console.error('OAuth callback error:', error);
      setError('Failed to complete connection. Please try again.');
      setTimeout(() => {
        navigate('/contractor/settings');
      }, 3000);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center space-y-4">
        {error ? (
          <>
            <div className="text-destructive text-lg font-medium">{error}</div>
            <div className="text-sm text-muted-foreground">
              Redirecting to settings...
            </div>
          </>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin mx-auto" />
            <div className="text-lg font-medium">Connecting your Stripe account...</div>
            <div className="text-sm text-muted-foreground">
              Please wait while we complete the connection.
            </div>
          </>
        )}
      </div>
    </div>
  );
} 